import React, { useCallback, useEffect, useState } from 'react';
import { Col, Label, Row, Spinner } from 'reactstrap';
import api from "../../../../services/api";

export default function LabourRequestApprovalDetail (props) {
    const {id} = props;
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [currentItem, setCurrentItem] = useState(null);

    const loadData = useCallback(() => {
        if (!id)
            return;

        setLoading(true);

        api.get(`recruitmentrequest/approvals/${id}`)
            .then((response) => {
                const {data} = response;

                if (!data?.length)
                {
                    setItems([]);
                    return;
                }

                setItems([
                    ...data.map(g => {
                        if (!g?.length)
                            return [];

                        return [
                            ...g.map(d => {
                                return {
                                    value: d.recruitmentApprovalId,
                                    label: d.approver?.displayName,
                                    disabled: true,
                                    current: d.status.lookupValue.toLowerCase().includes("pending"),
                                    approverName: d.approver?.displayName,
                                    approveRole: d.recruitmentApprovalFlow?.approvalRole?.approvalRoleName,
                                    status: d.status.lookupValue,
                                    inProgress: d.status.lookupValue.toLowerCase().includes("pending") || d.status.lookupValue.toLowerCase().includes("queue")
                                };
                            })
                        ];
                    })
                ]);

                setCurrentItem(data.filter(d => d.status.lookupValue.toLowerCase().includes("pending"))[0] ?? null);
            })
            .catch((error) => console.error({error}))
            .finally(() => setLoading(false))
        ;
    }, [id]);

    useEffect(() => {
        if (!id)
            return;

        loadData();
    }, [id]);

    const sidebarStyle = { height: "3px", backgroundColor: "#aaa" };

    return (
        <>
        {
            loading ? <div className="w-100 d-flex flex-wrap justify-content-center align-items-center"><Spinner color="default" type="border"  style={{ width: `1.5rem`, height: `1.5rem`, borderWidth: `0.2rem` }} /></div> : null
        }
        {
            items.map((g, g_idx) => {
                return (
                    <div className="w-100 d-flex flex-wrap justify-content-start align-items-start" key={`grouped_item_${g_idx}`}>
                    {
                        g.map((i, idx) => {
                            const iconName = i.current && i.inProgress ? "map-marker-alt" : (i.status.toLowerCase().includes("reject") || i.status.toLowerCase().includes("decline") ? "ban": (i.status.toLowerCase().includes("approve") || i.status.toLowerCase().includes("accept") ? "check" : "ellipsis-h"));
        
                            return (
                                <div key={`item_${idx}`} className="d-flex flex-wrap justify-content-center align-items-start" style={{minWidth: "150px"}}>
                                    <Row className="m-0 p-0 w-100" style={{height: "40px"}}>
                                        <Col xs={4} className="m-0 p-0 d-flex flex-wrap justify-content-center align-items-center">
                                        {
                                            idx > 0 ?
                                            <div className="w-100" style={sidebarStyle}></div>
                                            :
                                            null
                                        }
                                        </Col>
                                        <Col xs={4} className="m-0 p-0 d-flex flex-wrap justify-content-center align-items-center">
                                            <div className={`stepper-item-circle stepper-item-${i.current && i.inProgress ? "current" : (i.status.toLowerCase().includes("reject") || i.status.toLowerCase().includes("decline") ? "rejected": (i.status.toLowerCase().includes("approve") || i.status.toLowerCase().includes("accept") ? "approved" : "next"))} d-flex flex-wrap justify-content-center align-items-center`}>
                                                <i className={`fas fa-${iconName}`} />
                                            </div>
                                        </Col>
                                        <Col xs={4} className="m-0 p-0 d-flex flex-wrap justify-content-center align-items-center">
                                        {
                                            idx + 1 < items.length ?
                                            <div className="w-100" style={sidebarStyle}></div>
                                            :
                                            null
                                        }
                                        </Col>
                                    </Row>
                                    <Row className="m-0 p-0 w-100">
                                        <Col xs={12} className="m-0 p-0 d-flex flex-column justify-content-center align-items-center">
                                            <Label className="font-size-small-custom m-0"><b>{ i.approverName }</b></Label>
                                            <Label className="font-size-small-custom m-0">{ i.approveRole ?? null }</Label>
                                            <Label className="font-size-small-custom m-0">{ i.status }</Label>
                                        </Col>
                                    </Row>
                                </div>
                            );
                        })
                    }
                    </div>
                );
            })
        }
        </>
    );
}
